import { calculateCartTotal, calculateProductTotal } from '../redux/selectors/cartSelector';
import { MINIMUM_ALLOWED_ORDER_TOTAL, MINIMUM_ALLOWED_PRODUCT_PRICE } from '../constants/constants';
import { default as _u } from 'underscore';
import getProductWithAppliedAccount from '../mutators/getProductWithAppliedAccount';

/**
 * Returns false if the provided tariff services count is less than current services count user has.
 *
 * @param tariff - target tariff (with product ID) to check for
 * @param product
 * @param mainProduct
 * @param cart
 * @param [atLeastOnePeriod]
 * @return {boolean}
 */
function fx({ tariff, product, mainProduct, cart, atLeastOnePeriod}) {
    atLeastOnePeriod = atLeastOnePeriod ?? false;
    let result = true;

    product = getProductWithAppliedAccount(product, cart?.account);
    mainProduct = getProductWithAppliedAccount(mainProduct, cart?.account);

    if (atLeastOnePeriod) {
        return !!tariff && !!Object.values(tariff?.periods)?.find((period) => {
            const cartProducts = Object.values(cart?.products)?.map(item => {
                return getProductWithAppliedAccount({ ... item, tariff, period }, cart?.account);
            });
            return fx({
               tariff,
               product: { ...product, tariff, period },
               mainProduct: { ...mainProduct, tariff, period },
               cart: {
                   ...cart,
                   products: _u.object(cartProducts?.map(item => item?.product_id), cartProducts)
               }
            });
        });
    }
    if (typeof product === 'object') {
        const productInCart = {
            ...getProductWithAppliedAccount(cart?.products[product?.product_id] ?? null, cart?.account),
            period: mainProduct?.period
        };
        if (productInCart && mainProduct) {
            const cartAllProducts = Object.values(cart?.products)
                ?.map(item => {
                return {
                    ...getProductWithAppliedAccount({ ...item, tariff, period: mainProduct?.period }, cart?.account),
                    period: mainProduct?.period
                }
            });
            const cartProductsEx = cartAllProducts?.filter(item => item?.product_id !== product?.product_id);
            const totalCart = calculateCartTotal({
                ...cart,
                products: _u.object(cartProductsEx?.map(item => item?.product_id), cartProductsEx)
            });
            const totalProduct = calculateProductTotal({ ...productInCart, includeExtra: mainProduct?.includeExtra }, cart, true);
            const totalMainProduct = calculateCartTotal(
                {
                    ...cart,
                    products: _u.object(cartAllProducts?.map(item => item?.product_id), cartAllProducts)
                },
                { product_id: mainProduct?.product_id }
            );
            const total = (totalCart?.total ?? 0) + totalProduct;
            result = total > MINIMUM_ALLOWED_ORDER_TOTAL
                && (totalMainProduct?.total ?? 0) > MINIMUM_ALLOWED_PRODUCT_PRICE
                && (totalProduct ?? 0) > MINIMUM_ALLOWED_PRODUCT_PRICE;
        }
        const serviceCountCurrent = product?.services_count;
        if (result && serviceCountCurrent && tariff?.services) {
            result = tariff?.services >= serviceCountCurrent;
        }
    }
    return result;
}

export default fx;
